<template>
  <div id="certificaciones" class="py-5 container">
    <div class="row justify-content-center">
        <h1 class="certificaciones-title">Certificaciones</h1>
    </div>
    <div class="inner pt-3">
      <carousel :perPageCustom = "[[320, 1], [700, 2]]" :autoplayTimeout="4000" :loop="true" class="row car">
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class="cert-image" src="../assets/BASC50.png" alt="basc50" />
            <h2 class="text-header">BASC</h2>
            <p
              class="cert-text"
            >BASC -Business Alliance for Secure Commerce-, es una alianza empresarial internacional que promueve un comercio seguro en cooperación con gobiernos y organismos internacionales.</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="https://www.wbasco.org/es"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class="cpat cert-image" src="../assets/CTPAT-sf.png" alt="CTPAT" />
            <h2 class="text-header">CTPAT</h2>
            <p
              class="cert-text"
            >El C-TPAT es una iniciativa entre el gobierno de los Estados Unidos y la iniciativa privada con la finalidad de garantizar la seguridad en las distintas áreas de la cadena de suministro y protegerla en contra del terrorismo.</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="https://www.cbp.gov/border-security/ports-entry/cargo-security/ctpat"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class=" cert-image oea" src="../assets/oea.png" alt="OEA" />
            <h2 class="text-header">OEA</h2>
            <p
              class="cert-text"
            >El Operador Económico Autorizado (OEA), es un programa que busca fortalecer la seguridad en la cadena de suministros de comercio exterior a través de la implementación de estándares mínimos en materia de seguridad internacionalmente reconocidos.</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="http://omawww.sat.gob.mx/comext/esquema_integral/Paginas/OEA.aspx"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class="cert-image scac" src="../assets/scac.png" alt="SCAC" />
            <h2 class="text-header">SCAC</h2>
            <p
              class="cert-text"
            >Con la mentalidad y el objetivo de brindar un servicio más seguro, integral y con reconocimiento internacional, obtuvimos la recertificación con número MEXGDL00141-0102</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="http://www2.nmfta.org/pages/scac"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class="cert-image rc" src="../assets/rc.png" alt="rc" />
            <h2 class="text-header">Recurso Confiable</h2>
            <p
              class="cert-text"
            >Recurso confiable surge como resultado de la problemática que se vivía en la industria del transporte derivada de la inseguridad. Nuestros antecedentes son transportistas, por lo tanto conocemos de primera instancia mano las necesidades y características de dicha industria.</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="https://corp.recursoconfiable.com/?sourceDomain=app.recursoconfiable.com"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
        <slide class="col">
          <div img-top style="max-width: 20rem;" class="card mx-auto">
            <img class="cert-image tl" src="../assets/tl.png" alt="tl" />
            <h2 class="text-header">Transporte Limpio</h2>
            <p
              class="cert-text"
            >Programa nacional desarrollado por la STC Y SEMARNAT, con el objetivo de que el auto transporte federal de carga, pasaje, turismo y transporte privado que utilicen los caminos y puentes de jurisdicción federal así, como los usuarios del servicio de carga en las actividades operativas</p>
            <b-button
              pill
              class="info-button"
              target="_blank"
              href="http://www.semarnat.gob.mx/temas/gestion-ambiental/calidad-del-aire/transporte-limpio/acerca-del-programa"
              variant="primary"
            >Más</b-button>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  data() {
    return {};
  },
  components: {
    Carousel,
    Slide
  }
};
</script>

<style>
.certificaciones-title{
  font-size: 5vh;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.inner {
    margin: 0 auto;
    width: 70%;
}
.cert-image {
  display: block;
  margin: 10px auto;
  width: 40%;
}
.info-button {
  display: block;
  margin: 20px auto;
  width: 50%;
}
.cert-text {
  margin: 10px auto 0 auto;
  display: block;
  width: 90%;
  text-align: justify;
  max-height: 600px;
  min-height: 250px;
  font-size: 18px;
  color: #000;
}
.cpat {
  width: 90%;
  margin-top: 6%;
}
.scac {
  width: 68%;
}
.oea {
  width: 55%;
}
.rc{
  width: 75%;
}
.tl{
  width: 48%;
}
.text-header {
  text-align: center;
}
.card {
  margin: 0 30px;
  vertical-align: middle;
}
@media (min-width: 768px) {
  /* show 3 items */
  .carousel-inner .active,
  .carousel-inner .active + .carousel-item,
  .carousel-inner .active + .carousel-item + .carousel-item {
    display: block;
  }

  .carousel-inner
    .carousel-item.active:not(.carousel-item-right):not(.carousel-item-left),
  .carousel-inner
    .carousel-item.active:not(.carousel-item-right):not(.carousel-item-left)
    + .carousel-item,
  .carousel-inner
    .carousel-item.active:not(.carousel-item-right):not(.carousel-item-left)
    + .carousel-item
    + .carousel-item {
    transition: none;
  }

  .carousel-inner .carousel-item-next,
  .carousel-inner .carousel-item-prev {
    position: relative;
    transform: translate3d(0, 0, 0);
  }

  .carousel-inner
    .active.carousel-item
    + .carousel-item
    + .carousel-item
    + .carousel-item {
    position: absolute;
    top: 0;
    right: -33.3333%;
    z-index: -1;
    display: block;
    visibility: visible;
  }

  /* left or forward direction */
  .active.carousel-item-left + .carousel-item-next.carousel-item-left,
  .carousel-item-next.carousel-item-left + .carousel-item,
  .carousel-item-next.carousel-item-left + .carousel-item + .carousel-item,
  .carousel-item-next.carousel-item-left
    + .carousel-item
    + .carousel-item
    + .carousel-item {
    position: relative;
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  /* farthest right hidden item must be abso position for animations */
  .carousel-inner .carousel-item-prev.carousel-item-right {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    display: block;
    visibility: visible;
  }

  /* right or prev direction */
  .active.carousel-item-right + .carousel-item-prev.carousel-item-right,
  .carousel-item-prev.carousel-item-right + .carousel-item,
  .carousel-item-prev.carousel-item-right + .carousel-item + .carousel-item,
  .carousel-item-prev.carousel-item-right
    + .carousel-item
    + .carousel-item
    + .carousel-item {
    position: relative;
    transform: translate3d(100%, 0, 0);
    visibility: visible;
    display: block;
    visibility: visible;
  }
}
@media (min-width: 300px) and (max-width: 767px) {
  .certificaciones-title{
    font-size: 32px;
  }
  .inner{
    width: 100%;
    margin: 0 auto;
  }
}
</style>
